<template>
  <div class="spinner-page" v-if="isNewsPageLoading || isNewsSideBarLoading">
    <q-spinner class="spinner" color="primary" size="3em" />
  </div>
  <div v-else class="news-page">
    <div class="main">
      <SideBar />

      <div class="news-items">
        <div class="pagination top-pag">
          <div class="results-info column">
            <span class="results-item"
              >Pagina {{ currentPage }} van de {{ maxPages }}</span
            >
          </div>
          <q-pagination
            class="pagination-item"
            v-model="current"
            color="black"
            outline
            direction-links
            :max="maxPages"
            :max-pages="6"
            boundary-numbers
            @click="goToPage(current)"
          ></q-pagination>
        </div>
        <SearchBar />

        <div class="row top-options-row">
          <div class="row view-select-icons q-pt-sm">
            <i
              class="las la-2x la-table action-icon"
              @click="enableViewAsTable()"
            >
              <q-tooltip>
                Bekijk als tabel
              </q-tooltip></i
            >
            <i
              class="las la-2x la-bars action-icon"
              @click="disableViewAsTable()"
            >
              <q-tooltip>
                Bekijk als lijst
              </q-tooltip></i
            >
          </div>
          <div class="row justify-end q-mb-md dropdown-container">
            <!--     <a
              style="text-decoration: none"
              class="q-mr-md operators-help"
              href="https://www.vindsubsidies.nl/faq-database/"
              target="_blank"
            >
              Meer informatie over zoeken met operatoren
            </a> -->
            <p class="sort-heading q-mt-sm">Sorteer op:</p>
            <q-select
              class="sort-select"
              dense
              v-model="selectedSort"
              input-debounce="0"
              :options="sortOptions"
              behavior="menu"
              bg-color="white"
              outlined
            />
          </div>
        </div>
        <div v-if="!isTableView">
          <NewsItem
            v-for="news in allNews"
            :key="news.id"
            :newsTitle="news.title"
            :newsItem="news"
            :intro="news.introduction"
            :id="news.id"
            :body="news.body"
          />
        </div>

        <div v-else class="table-container">
          <q-table
            :rows="allNews"
            :columns="newsTableColumns"
            row-key="id"
            :filter="filterSchemes"
            :filter-method="schemesFilter"
            class="news-table"
            :hide-pagination="true"
            :rows-per-page-label="'Resultaten per pagina'"
            :rows-per-page-options="[25]"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="titel" :props="props" class="title-row">
                  <router-link
                    :to="{
                      name: 'NewsDetails',
                      params: { newsId: props.row.id },
                    }"
                    style="text-decoration: none"
                    class="title-row"
                  >
                    <div v-html="props.row.title"></div>
                  </router-link>
                </q-td>

                <q-td key="datum" :props="props">{{
                  formatDate(props.row.date)
                }}</q-td>
              </q-tr>
            </template>
          </q-table>
        </div>

        <div class="pagination">
          <q-pagination
            class="pagination-item"
            v-model="current"
            color="black"
            outline
            direction-links
            :max="maxPages"
            :max-pages="6"
            boundary-numbers
            @click="goToPage(current)"
          ></q-pagination>
        </div>
      </div>
    </div>

    <div class="circle-container">
      <div id="pagetop" class="top-scroll" v-if="scY > 300">
        <i class="las la-2x la-angle-up up-icon" @click="toTop">
          <q-tooltip self="center left" :offset="[10, 10]"
            >Naar boven</q-tooltip
          >
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, onMounted, onUnmounted } from 'vue';
import store from '../store/index';
import NewsService from '../services/news.service';
import SearchBar from '../components/news-components/NewsSearch.vue';
import NewsItem from '../components/news-components/NewsItem.vue';
import SideBar from '../components/news-components/NewsSideBarSearch.vue';
import FiltersService from '../services/filters.service';
import NewsUtils from '..//utils/news';
import moment from 'moment';

export default {
  components: {
    SearchBar,
    NewsItem,
    SideBar,
  },
  setup() {
    const newsSearchTerm = computed({
      get: () => store.state.newsSearch.searchText,
    });

    const isSearchNewsWithSchemesFilters = computed({
      get: () => store.state.advancedSearch.isSearchNewsWithSchemesFilters,
    });

    onMounted(async () => {
      var isDefaultSearch = NewsUtils.checkIsDefaultSearch();

      if (!isSearchNewsWithSchemesFilters.value) {
        if (newsSearchTerm.value.length > 0 || !isDefaultSearch) {
          await NewsUtils.searchNews();
        } else {
          await NewsService.loadDefaultNews();
        }
      }

      FiltersService.getDefaultFilters();
      window.scrollTo(0, 0);
      window.addEventListener('scroll', handleScroll);
      store.commit('advancedSearch/clearSearchText');
      store.commit('advancedSearch/resetSearchFilter', false);
    });

    onUnmounted(() => {
      store.commit('advancedSearch/updateDisplayNumberOfNewsResults', false);
    });

    /*  const maxPages = computed({
      get: () => store.state.news.maxPages,
    }); */
    const maxPages = computed({
      get: () => store.state.newsSearch.pageCount,
    });

    const allNews = computed({
      get: () => store.state.news.allNews,
    });

    /*    const searchText = computed({
      get: () => store.state.news.searchText,
    }); */

    const searchText = computed({
      get: () => store.state.newsSearch.searchText,
    });

    const orgsIncludeString = computed({
      get: () => store.state.newsSearch.organisationsIncludeString,
    });

    const orgsExcludeString = computed({
      get: () => store.state.newsSearch.organisationsExcludeString,
    });

    const goToPage = async (current) => {
      store.commit('news/updateCurrentPage', current);
      store.commit('newsSearch/createOrganisationsIncludeString');
      store.commit('newsSearch/createOrganisationsExcludeString');
      /*       await NewsService.getResulstsByPage(
        current - 1,
        searchText,
        dateFrom,
        dateTo,
        audienceTags,
        schemesTags,
        locationsTags,
        purposesTags, */
      //This is just hidden for now, don't remove it:
      //industriesTags,
      /*         orgsIncludeString,
        orgsExcludeString,
        selectedSort
      ); */
      await NewsUtils.searchNewsByPage(isTableView.value);

      window.scrollTo(0, 0);
    };

    /*     const searchNewsSchemeName = async (title) => {
      await NewsService.getSearchResults(
        title,
        dateFrom,
        dateTo,
        audienceTags,
        schemesTags,
        locationsTags,
        purposesTags,
        //This is just hidden for now, don't remove it:
        //industriesTags,
        orgsIncludeString,
        orgsExcludeString,
        selectedSort
      );
    };
 */
    const currentPage = computed({
      get: () => store.state.news.currentPage,
    });

    const dateFrom = computed({
      get: () => store.state.newsSearch.dateFrom,
    });

    const dateTo = computed({
      get: () => store.state.newsSearch.dateTo,
    });
    const current = ref(currentPage.value);

    const audienceTags = computed({
      get: () => store.state.newsSearch.selectedAudiences,
    });

    const locationsTags = computed({
      get: () => store.state.newsSearch.selectedLocations,
    });

    const purposesTags = computed({
      get: () => store.state.newsSearch.selectedPurposes,
    });

    const schemesTags = computed({
      get: () => store.state.newsSearch.selectedSchemeTypes,
    });

    //This is just hidden for now, don't remove it:
    /*
    const industriesTags = computed({
      get: () => store.state.newsSearch.selectedIndustries,
    });
    */

    const scTimer = ref(0);
    const scY = ref(0);
    const handleScroll = () => {
      if (scTimer.value) return;
      scTimer.value = setTimeout(() => {
        scY.value = window.scrollY;
        clearTimeout(scTimer.value);
        scTimer.value = 0;
      }, 100);
    };

    const toTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };

    const isNewsPageLoading = computed({
      get: () => store.state.news.isNewsPageLoading,
    });

    const isNewsSideBarLoading = computed({
      get: () => store.state.news.isNewsSideBarLoading,
    });

    const sortOptions = ['Nieuwste', 'Oudste', 'Relevantie'];

    const selectedSort = computed({
      get: () => store.state.newsSearch.selectedSortNews,
      set: (value) => {
        store.commit('newsSearch/updateSelectedSortNews', value);
        NewsUtils.searchNews(isTableView.value);
      },
    });

    const newsTableColumns = [
      {
        name: 'titel',
        align: 'left',
        label: 'Titel',
        field: 'titel',
        sortable: false,
      },
      {
        name: 'datum',
        align: 'left',
        label: 'Datum',
        field: 'datum',
        sortable: false,
      },
    ];

    const formatDate = (stringDate) => {
      const dateN = new Date(stringDate);
      return moment(dateN).format('DD-MM-YYYY');
    };

    const isTableView = computed({
      get: () => store.state.newsSearch.isTableView,
    });

    const enableViewAsTable = () => {
      store.commit('newsSearch/changeIsTableView', true);
      NewsUtils.searchNews(true);
    };

    const disableViewAsTable = () => {
      store.commit('newsSearch/changeIsTableView', false);
      NewsUtils.searchNews(false);
    };
    return {
      isSearchNewsWithSchemesFilters,
      enableViewAsTable,
      disableViewAsTable,
      isTableView,
      formatDate,
      newsTableColumns,
      sortOptions,
      selectedSort,
      isNewsSideBarLoading,
      isNewsPageLoading,
      newsSearchTerm,
      handleScroll,
      scTimer,
      scY,
      toTop,
      maxPages,
      current,
      goToPage,
      allNews,
      currentPage,
      orgsIncludeString,
      orgsExcludeString,
      searchText,
      dateFrom,
      dateTo,
      //This is just hidden for now, don't remove it:
      //industriesTags,
      schemesTags,
      purposesTags,
      audienceTags,
      locationsTags,
    };
  },
};
</script>
